<template>
  <span class="text-white/40 text-[12px] font-semilight">Powered by Xangle</span>
</template>